import React from "react";
import PembuatanVAMenu from "../components/menu/admin/PembuatanVAMenu";

const PembuatanVA = () => {
  return <PembuatanVAMenu />;
};

export default PembuatanVA;
